<div class="sticky-top" id="section-capacite">
  <app-back-to-top></app-back-to-top>
</div>
<div class="wrapper">
  <section class="feature-inactive">
    <figure class="icon-container">
      <img src="{{ 'assets/images/icone-indispo.svg' | cheminAbsoluStatique }}" alt="" width="30" height="30" />
    </figure>
    <div class="content">
      <h1 class="titre" id="titre-page">{{ 'feature-inactive.titre' | translate }}</h1>
      <p class="texte" [innerHTML]="'feature-inactive.texte' | translate"></p>
      <p
        class="texte"
        [innerHTML]="
          'feature-inactive.obtenir-conseils' | translate: { numeroCapSansFrais: numero1, numeroSansFrais: numero2 }
        "
      ></p>
      <button
        class="content-btn white full-width-m desktop"
        mat-button
        (click)="navigateTo('/')"
        [innerText]="'feature-inactive.bouton-dashboard' | translate"
      ></button>
      <button
        class="content-btn white full-width-m mobile"
        mat-button
        (click)="navigateTo('/')"
        [innerText]="'feature-inactive.bouton-dashboard-short' | translate"
      ></button>
    </div>
  </section>
</div>
